import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IMeetingByDatePayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const meetingByDateSlice = createSlice({
    name: 'meeting-statistics/meeting-by-date',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMeetingByDatePayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const meetingByDateActions = meetingByDateSlice.actions
export default meetingByDateSlice.reducer
